import { FEATURES } from '@/access/features';

export default {
  type: 'checkr',
  engagement: true,
  icon: 'checkr',
  title: 'Checkr Background Check',
  help: 'Collect Checkr disclosure and consent for a background check package',
  is_new: true,
  feature: FEATURES.CHECKR,
  schema: {
    contact_info_note: {
      type: 'Content',
      content:
        "The contact's <strong>email</strong>, <strong>first name</strong>, and <strong>last name</strong> " +
        'are sent to Checkr automatically from the contact profile. Map additional fields below based on ' +
        'your Checkr package requirements.',
    },

    package_fields_note: {
      type: 'Content',
      content:
        '<strong>Criminal background check packages</strong> typically require SSN and ZIP code. ' +
        '<strong>MVR (motor vehicle record) packages</strong> typically require driver license number and state. ' +
        'Package slugs are custom to your Checkr account — map the fields your package needs.',
    },

    account_name: {
      type: 'Text',
      title: 'Account Name',
      help: 'Display name shown in the Checkr embed. Defaults to your organization name.',
      default: '',
    },

    package_slug: {
      type: 'Text',
      title: 'Package Slug',
      help: 'Checkr package slug for this background check (e.g. basic). Consent is tracked per slug.',
      default: 'basic',
      validators: ['required'],
    },

    package_slug_lookup: {
      type: 'Content',
      content:
        'Need help finding the slug? ' +
        '<a href="/plugin/checkr/packages" target="_blank" rel="noopener noreferrer">' +
        'Browse your Checkr packages</a> (opens in a new tab).',
    },

    work_location_state_field: {
      type: 'ContactFieldList',
      title: 'Work Location State',
      help: 'Required. Select the contact field that contains the work location state.',
      default: '',
      validators: ['required'],
    },

    work_location_city_field: {
      type: 'ContactFieldList',
      title: 'Work Location City',
      help: 'Optional. Select the contact field that contains the work location city.',
      default: '',
    },

    zip_code_field: {
      type: 'ContactFieldList',
      title: 'Zip Code',
      help: 'Optional. Required for many criminal background check packages per Checkr.',
      default: '',
    },

    ssn_field: {
      type: 'ContactFieldList',
      title: 'SSN',
      help: 'Optional. Required for many criminal background check packages per Checkr.',
      default: '',
    },

    dob_field: {
      type: 'ContactFieldList',
      title: 'Date of Birth',
      help: 'Optional. May be required depending on your Checkr package.',
      default: '',
    },

    driver_license_number_field: {
      type: 'ContactFieldList',
      title: 'Driver License Number',
      help: 'Optional. Required for MVR (motor vehicle record) packages per Checkr.',
      default: '',
    },

    driver_license_state_field: {
      type: 'ContactFieldList',
      title: 'Driver License State',
      help: 'Optional. Required for MVR packages. Also passed to the Checkr consent embed when mapped.',
      default: '',
    },

    button_text: {
      type: 'Text',
      title: 'Custom Button Text',
      help: 'Customize the text of the button that opens the background check.',
      default: 'Start Background Check',
    },

    success_text: {
      type: 'Text',
      title: 'Success Message',
      help: 'Message shown after disclosure and consent are complete.',
      default: 'Background check started! You are all set.',
    },

    open_popup: {
      type: 'Checkbox',
      title: 'Show immediately',
      default: true,
    },

    can_advance: {
      type: 'Checkbox',
      default: false,
      title: 'Can Skip. Do not require.',
      help: 'Allow advancing without completing the background check.',
    },

    fake_mode: {
      type: 'Checkbox',
      title: 'Fake Mode (preview only)',
      help:
        'Simulate the Checkr embed without API calls. Only applies in the lesson editor/preview — ' +
        'ignored when contacts take the lesson. Use staging credentials for real test flows.',
      default: false,
    },
  },
};
